<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'Wapper'
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Wapper.vue